// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	recaptchaKey: '6LfhtKkUAAAAAChd_kuqcXzpWWO5wtpwOHO-VOlz',
	apiUrl: 'https://develop-app.cameconnect.net/api',
	apiUrlThermo: 'https://develop-thermo.cameconnect.net',
	websocketUrl: 'wss://develop-app.cameconnect.net/api/events-real-time',
	websocketUrlThermo: 'wss://develop-thermo.cameconnect.net:8443/WebSocket',
	oldFrontEnd: 'https://app-develop-legacy.cameconnect.net',
	frontEnd: 'https://app-develop.cameconnect.net',
	googleAPI: 'AIzaSyCbkFhrcqdJlqyz09SnN6rxeaLVsuANH0s',
	clientId: '2JFVU0A4KXLYo3zJO1NMuKpTuI4Ryfya',
	apiStatus: 'https://servicestatus.cameconnect.net/',
	statusEnv: 'develop',
	// eslint-disable-next-line max-len
	clientSecret: 'MQQFhzVZCXUD87TwP21L3ALdJYcPGCCPSqQTjMrnwG5SwQY6w6xFa9hnidS9KkZb8MMUBJJC8U2UdpFqdUVjbXtzdNqUk9eDu72VF6YdKTq8Z8ULzmbcAvgEiNwzZq2x6RLxF7ewCqAMUcUBPEAXhJwqv7j6f3bxJZNZZmLpWn5b8MqVxwk6CNq0C6uVTrRJuwTEkY23Vpq5Atwyq0QataMwcYDTZCFJgJJ1DiBRdMmHX0tXE4gnSLiJEF70LXfG',
	// Firebase
	firebase_apiKey: "AIzaSyDazR7lqi8A_oJ0za1QFxFpDznDo2rhB5w",
	firebase_authDomain: "cameconnect-analytics-v2.firebaseapp.com",
	firebase_projectId: "cameconnect-analytics-v2",
	firebase_storageBucket: "cameconnect-analytics-v2.firebasestorage.app",
	firebase_messagingSenderId: "280100852754",
	firebase_appId: "1:280100852754:web:125dc594c384ffdade74cb",
	firebase_measurementId: "G-VSGE5F4WE5"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
